import { render } from "./NewChronologyForm.vue?vue&type=template&id=2ad283dd&scoped=true"
import script from "./NewChronologyForm.vue?vue&type=script&lang=js"
export * from "./NewChronologyForm.vue?vue&type=script&lang=js"

import "./NewChronologyForm.vue?vue&type=style&index=0&id=2ad283dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad283dd"]])

export default __exports__